import React from 'react'
import { useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'

import BaseModalActions from 'components/Modals/BaseModalActions'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { DeleteButton } from 'components/UI'
import { Badge, List } from 'ui'
import { t } from 'translations'

const ActionsModal = ({ actions }) => {
  const dispatch = useDispatch()

  // Sort into groups to allow defining headers without requiring a nested structure
  let actionGroups = []
  // Add a default header if the first action is not a header
  if (actions.length && !actions[0].header) actionGroups.push({ header: 'components.ACTIONS', subActions: [] })
  for (const action of actions) {
    // Auto detect headers
    if (action.header) actionGroups.push({ ...action, subActions: [] })
    else actionGroups[actionGroups.length - 1].subActions.push(action)
  }

  return (
    <BaseModalActions>
      {actionGroups.map((actionGroup, index) => {
        return (
          <List key={index} className="mb-2">
            {actionGroup.header && actionGroup.header !== ' ' ? (
              <List.Item className="pb-0">
                <h6>{t(actionGroup.header)}</h6>
              </List.Item>
            ) : null}

            {actionGroup.subActions.map((action, index) => {
              if (!action) return null

              // Handle link action
              if (action.link) {
                return (
                  <NavLink
                    key={index}
                    onClick={() => dispatch(closeModal())}
                    to={action.link}
                    className="list-group-item list-group-item-action list-group-flush"
                  >
                    {t(action.text)}
                    {action.devAction ? (
                      <Badge variant="warning" className="ml-1">
                        Dev
                      </Badge>
                    ) : null}
                  </NavLink>
                )
              }

              // Handle button action
              if (action.onClick) {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      dispatch(closeModal())
                      action.onClick()
                    }}
                    className="list-group-item list-group-item-action list-group-flush"
                  >
                    {t(action.text)}
                    {action.devAction ? (
                      <Badge variant="warning" className="ml-1">
                        Dev
                      </Badge>
                    ) : null}
                  </Button>
                )
              }

              // Handle remove action
              if (action.remove) {
                return (
                  <DeleteButton
                    key={index}
                    onClick={() => {
                      dispatch(closeModal())
                      action.remove()
                    }}
                    title={action.text}
                    buttonClass="list-group-item list-group-item-action list-group-flush"
                  />
                )
              }

              return null
            })}
          </List>
        )
      })}
    </BaseModalActions>
  )
}

export default ActionsModal
